import { Carousel } from 'flowbite-react';
import React from 'react';
import img1 from '../../Media/pepid-pulse-logo-v3.png';
import img2 from '../../Media/BA2-Variant-Hero2.jpg';

const Section6 = () => {
    return (
        <div className=''>
            <hr />
            <div className="h-56 sm:h-64 xl:h-80 2xl:h-96">
                <Carousel>
                    <div className="flex h-full items-center justify-center">
                        <div>
                            <p className='md:text-3xl text-xl font-semibold text-center px-10'>"I use PEPID all the time in the ED and have for years. I appreciate all the effort and the good solid product. More than once I have been a better doctor because of PEPID."</p>
                            <h2 className='text-center md:text-2xl text-lg font-bold text-gray-600 pb-10'>Alex Mohseni, MD</h2>
                        </div>
                    </div>
                    <div className="flex h-full items-center justify-center">
                        <div>
                            <p className='md:text-3xl text-xl font-semibold text-center px-10'>PEPID is a comprehensive, reliable tool that you’ll use almost as often as your stethoscope.</p>
                            <h2 className='text-center md:text-2xl text-lg font-bold text-gray-600 pb-10'>Alex Mohseni, MD</h2>
                        </div>
                    </div>
                </Carousel>
            </div>
            <div className='w-10/12 mx-auto text-center'>
                <h3 className='text-3xl '>Ready to get started?</h3>
                <button className='text-2xl font-bold text-white bg-primary-500 hover:bg-primary-600 px-6 py-2 rounded-full my-5'>START A 2-WEEK FREE TRIAL</button>
                <div className='flex justify-center my-10'>
                    <img src={img1} alt="" />
                </div>
                <h3 className='text-3xl text-gray-600'>Timely Insights for Healthcare Experts </h3>
                <div className='md:w-9/12 mx-auto'>
                    <div className='flex justify-center my-10'>
                        <img src={img2} alt="" />
                    </div>
                    <h3 className='font-bold text-3xl text-primary-600 text-left'>Omicron Variant: BA.2</h3>
                    <p className='text-xl text-left mt-2'>Omicron Variant: BA.2 Sublineage By Hannah Morpurgo and Julia Schurr According to the World Health Organization, by February 19, 2022, BA.2 had been detected in 74 countries and 47 US states. BA.2 is a subvariant of Omicron which, according to studies from the UK and...</p>
                    <p className='text-xl text-left text-primary-600 mt-2'>Read More</p>
                </div>
            </div>
        </div>
    );
};

export default Section6;